import React from "react";
import { Outlet, Link } from "react-router-dom";
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { initializeCartData } from "../ShoppingCart/CartData";
import CartItemBadge from "../ShoppingCart/CartItemBadge";
import { SocialMedia } from "../SocialMedia";

const Menu = (): any => {
  initializeCartData("Cart");
  return (
    <div>
      <div className="section">
        <nav className="navbar navbar-expand-lg fixed-top nav-down">
          <div className="container">
            <div className="navbar-translate">
              <div className="navbar-brand">
                <h3>Hanna Kaciniel</h3>
              </div>

              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navigation"
                aria-controls="navigation-index"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-bar bar1"></span>
                <span className="navbar-toggler-bar bar2"></span>
                <span className="navbar-toggler-bar bar3"></span>
              </button>
            </div>
            <div
              className="collapse navbar-collapse"
              data-nav-image="#"
              data-color="orange"
            >
              <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                  <Link className="nav-link" to={`about`}>
                    About
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={`paintings/:Params`}>
                    Paintings
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={`availableprints/:Params`}>
                    Prints
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={`contact`}>
                    Contact
                  </Link>
                </li>

                {/*<li className="nav-item">
                  <Link className="nav-link" to={`news`}>
                    News
                  </Link>
                </li>
                
                */}
                <li className="nav-item">
                  <Link className="nav-link" to={`shoppingcart/:Params`}>
                    <span className="fa fa-search">
                      <FontAwesomeIcon icon={faCartShopping} size="xl" />
                    </span>
                    <CartItemBadge />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
      <div className="section">
        <div id="detail" className="container">
          <SocialMedia Class="col-md-12 social-media" Type="Header" />
          <Outlet />
        </div>
      </div>
    </div>
  );
};
export default Menu;
